

// document.addEventListener("DOMContentLoaded", () => {
// 	console.log("Document is ready");
// });

// add scrollMarginTop when fixed header 
var headerHeight = document.querySelector("header").clientHeight;
document.querySelector(".contentwrapper").style.marginTop = headerHeight + "px";
document.querySelector("#top").style.scrollMarginTop = headerHeight + "px"; 

window.onload = function () {
	// console.log("window onload - it works")
	scrollactions.init();
	// mijntest.init();
	// collapse.init();
	// hovercollapse.init();
	// dropdown.init();
	// mobileFilter.init();
	// search.init();
	// toast.init(); 
	// youtubesetsource.init(); // moet na fixedheader ingeladen worden
}
// window.onresize = function () {
	// console.log("window onresize - it works")
	// var screenwidth = $(window).outerWidth()
	// console.log('screenwidth = ' + screenwidth);
	// mobileFilter.init(); 
// };
 
